<template>
  <div class="col-12 pt3">
    <div class="flex justify-center center">
      <h5 v-if="captain" class="h5 m1 bold">{{ title }}</h5>
    </div>

    <div v-if="!errorMessage" class="mt2 red center bold h6">
      {{ isUserAlreadyInSession ? 'Vous êtes déjà inscrit à la session !' : 'Oups, l\'équipe est déjà complète !' }}
    </div>

    <div v-else class="mt2 red center bold h6">
      {{ errorMessage }}
    </div>

    <!-- <div>
      icon
    </div> -->

    <div>
      <p class="violet bold center h6">Envie de jouer ?</p>
      <p class="violet bold center h6">Réserve ton terrain !</p>

      <Button
        :action="() => reddirect()"
        color="violet-bg"
        border="violet-bd"
        text-size="h6"
        text="Réserver mon terrain"
      />
    </div>
  </div>
</template>

<script setup>

import { computed } from 'vue';
import { useStore } from '@/store/index';

import Button from '@/components/elements/Button.vue';

const store = useStore();

const sessionParticipants = computed(() => (store.state.courtSettings?.session?.participants || []).filter(p => !p.qrcode || (p.qrcode && p.qrcode !== 'None')));

const captain = computed(() => store.state.courtSettings?.session?.captain);

const errorMessage = computed(() => store.state.courtSettings?.errorMessage);

const isUserAlreadyInSession = computed(() => {
  if (store.state.courtSettings?.session?.allParticipants) {
    return store.state.courtSettings.session.allParticipants.some(p => p === store.state.user.horanet_id);
  }
  return (sessionParticipants.value || []).some(p => p.uuid === store.state.user.horanet_id);
});

const title = computed(() => (`${captain.value?.firstname || ''} t’invite à rejoindre sa partie`));

const reddirect = () => {
  const { site_preroute, site_url } = store.state.siteInfo;

  const baseUrl = `${process.env.VUE_APP_UCPA_DOMAIN}/${site_preroute}/${site_url}`;
  const impersonateToken = store.state.impersonateData;

  if (impersonateToken) {
    window.location.href = `${baseUrl}?impersonateData=${impersonateToken}`;
    return;
  }

  window.location.href = baseUrl;
};

</script>
